// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.search-boxx .el-col[data-v-b25c31f6] {\r\n  margin-bottom: 18px;\n}\n.gz-form-row[data-v-b25c31f6]{\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-wrap: wrap;\r\n      flex-wrap: wrap;\n}\n.fixed[data-v-b25c31f6]{\r\n  position: fixed;width: 100%;\r\n  background-color: #FFF;\r\n  z-index: 10;\r\n  border-bottom: 1px solid  #c3c3c3;\r\n  height: 40px;\n}\r\n", ""]);
// Exports
module.exports = exports;
